/**
 * Labstep
 *
 * @module components/OrderRequest/Form/ShowEdit/Quantity
 * @desc Form to update order request quantity
 */

import { fieldQuantity } from 'labstep-web/components/OrderRequest/Form/fields';
import { FormShowEditText as ShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import { OrderRequest } from 'labstep-web/models/order-request.model';
import type React from 'react';
import type { OrderRequestFormShowEditQuantityProps } from './types';

export const OrderRequestFormShowEditQuantity: React.FC<
  OrderRequestFormShowEditQuantityProps
> = ({ orderRequest }) => (
  <ShowEditText
    entityName={OrderRequest.entityName}
    entity={orderRequest}
    field={fieldQuantity}
  >
    {orderRequest.quantity}
  </ShowEditText>
);
